<template>
<div>   

    <el-col   :span="23"    class="affix_wrap"  >
        <div class="affix_box"  v-for="(item) of affixfileList"   :key="item.id">
            <div class="up">  
                
                <img v-if='item.fileName.search(/\.pdf/i)!=-1' src="@/assets/images/PDF.png" alt="" @click="OpenFile(item.tempLink)"> 
                <img v-else-if='item.fileName.search(/\.doc/i)!=-1  ' src="@/assets/images/word.png" alt="" @click="OpenFile(item.tempLink)"> 
                <img v-else-if='item.fileName.search(/\.xls/i)!=-1 || item.fileName.indexOf(".csv")!=-1' src="@/assets/images/excel.png" alt="" @click="OpenFile(item.tempLink)"> 
                <img v-else-if='item.fileName.search(/\.ppt/i)!=-1  ' src="@/assets/images/ppt.png" alt="" @click="OpenFile(item.tempLink)">  

                <img v-else-if="isImg(item.fileName)" :src="item.tempLink" :alt="item.fileName" @click="CheckFile(item)">
                <img v-else  src="@/assets/images/unknowfile.png" :alt="item.fileName"  @click="OpenFile(item.tempLink)">

  

          

                                 <!-- :limit="2"
                    :http-request="UpLoadFilesHandle"
                    :data="uploadData"
                    :on-success="handleUploadSuccess"
                    :file-list="file_list"
                    :before-upload="handleUploadbefore" 
                    :on-progress="handleUploadProgress"
                    :on-remove="handleRemoveFile" -->


            </div>
            <div class="down">{{item.fileName}}  </div>

            
        </div>

        <div v-if="isEdit" class="el-upload el-upload--picture-card"  style="margin-left:5px;margin-top:5px" @click="ShowUpload">     
            <i class="el-icon-plus" style="font-size:40px"></i>
         
        </div>
        
            <!-- <el-upload
                style="margin-left:5px;margin-top:5px"
                action="https://jsonplaceholder.typicode.com/posts/"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove">
                <i class="el-icon-plus"></i>
            </el-upload> -->
        <!-- <div>
            <el-upload
                class="upload-affix"
                drag
                action="https://lawassist.oss-cn-hangzhou.aliyuncs.com"
                :multiple='false'
                accept=".wav,.flv,.mp4,.m4a,.mp3,.amr,.WAV,.FLAC,.OPUS,.M4A',.MP3,.AMR,.MP4"

                >
                <i class="el-icon-upload"  ></i>
                <div class="el-upload__span" >将文件拖到此处，或<em>点击上传</em></div>
        
            </el-upload>


        </div> -->

            
    </el-col>


    <el-dialog :visible.sync="dialogVisible"  custom-class="detail_dia"    top='5vh' >
        <img   style="max-width:100%;height:auto" :src="dialogImageUrl" alt=""  >
    </el-dialog>


    <el-dialog :visible.sync="upLoadSig"  custom-class="detail_dia2"      >
        <el-upload
            class="upload-affix"
            style="height:100%"
            drag
            action="https://lawassist.oss-cn-hangzhou.aliyuncs.com"
            :http-request="UpLoadFilesHandle"
      

            >
            <i class="el-icon-upload"  ></i>
            <!-- :multiple='false' -->
            <div class="el-upload__span" >将文件拖到此处，或<em>点击上传</em></div>
           
    
        </el-upload>
        <!-- accept=".wav,.flv,.mp4,.m4a,.mp3,.amr,.WAV,.FLAC,.OPUS,.M4A',.MP3,.AMR,.MP4" -->


    </el-dialog>



</div>
    
	 
	
</template>

<script>
 

	export default { 
    name: 'affix_box22', 
    props: {
            // detail_visible:Boolean,
            // current_form:Object,
            affixfileList:Array,
            isEdit:Boolean
        },

        data() {
			return { 
            //    detail_visible:true ,
                // detail_visible:false,
                screenHeight:window.innerHeight || '',
                dialogVisible:false,
                dialogImageUrl:'',

                upLoadSig:false
           
			}
        },
        mounted(){
            console.log('111111111')
           
        },
        methods: {
            CheckFile(item){

                console.log('check file item:',item)
               
                this.dialogImageUrl = item.tempLink ;
                this.dialogVisible = true;

                // window.open(item.tempLink)


            },

            OpenFile(tempLink){
                console.log('OpenFile--------')
                window.open(tempLink, "_blank")

            },
            isImg(filename){
                //  return [
                //     '.png', '.jpg', '.jpeg', '.bmp', '.gif', '.webp', '.psd', '.svg', '.tiff'].
                //     indexOf(ext.toLowerCase()) !== -1;


                return (/\.(gif|jpe?g|tiff?|png|webp|bmp)$/i).test(filename);


            },
            ShowUpload(){
                this.upLoadSig=true
            }


        }
	}
</script>

<style >
 .detail_dia{
    overflow-y: scroll;
    max-height: 90vh;
    border-radius: 5px;
 }

  .detail_dia2{
    width:600px;
    /* height: 70vh; */
    border-radius: 5px;
 }


 
.affix_wrap{
    display:flex; 
    flex-direction:row;
    flex-wrap: wrap;
    border: 1px dashed #1557a1;
}

.affix_box{
    /* background-color: #fbfdff; */
    /* border: 1px solid #c0ccda; */
    /* border: 1px solid #1557a1; */

    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 148px;
    /* height: 148px; */
    height: 178px;
    /* line-height: 146px; */
    /* vertical-align: top; */
    margin-left: 10px;

    cursor: pointer;
    display: flex;
    flex-direction: column;

}

.affix_box .up{
    height: 148px;
    width: 100;
}

.affix_box .down{
    height: 30px;
    width: 100%;
    /* border: 1px solid #c0ccda; */
    line-height: 30px;
    font-size:10px;
    overflow: hidden;
    text-align: center;
}

.affix_box img{
    width:100% ;
    /* max-height: 100%; */
}

.el-upload-dragger{
    width: 50vh;
    height: 260px;

  

    border: 1px solid #c0ccda;

}
.el-upload-upload{
    margin: 40px 0 16px;

}

.upload-affix{
    /* border: 1px solid #031b36;  */
    height: 100%;
    text-align: center;
    /* width: 50px; */
	/* margin-top:30px; */
	/* padding: 6px; */
	/* border:1px solid #222; */
	/* display: flex;
	flex-direction: column;

	justify-content: center;
	align-items: center; */
}

.upload_box{
    border: 1px solid #031b36;
    /* height: 100%;
    width: 140px; */
    width: 148px;
    /* height: 148px; */
    height: 158px;
    margin: auto 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    
}

</style>
